import { jsxs as c, jsx as e } from "react/jsx-runtime";
import { Stack as n } from "@mui/material";
import { ChoiceBoxLabel as s } from "./styles62.mjs";
import { Typography as p } from "./index59.mjs";
import { Switch as m } from "./index65.mjs";
import { StyledRadio as b } from "./styles48.mjs";
import { StyledCheckbox as f } from "./styles3.mjs";
const T = ({
  label: t,
  text: l,
  type: i,
  fullWidth: d = !0,
  hasError: o = !1,
  controlPosition: u = "end",
  variant: a = "box",
  ...r
}) => /* @__PURE__ */ c(
  s,
  {
    $fullWidth: d,
    $hasError: o,
    $controlPosition: u,
    $variant: a,
    children: [
      /* @__PURE__ */ c(n, { direction: "column", gap: 1, flexGrow: 1, children: [
        /* @__PURE__ */ e(p.Body1, { children: t }),
        l && /* @__PURE__ */ e(p.Body2, { color: "text.secondary", children: l })
      ] }),
      i === "checkbox" && /* @__PURE__ */ e(
        f,
        {
          disableRipple: !0,
          disableFocusRipple: !0,
          disableTouchRipple: !0,
          color: o ? "error" : "info",
          $hasError: o,
          ...r
        }
      ),
      i === "radio" && /* @__PURE__ */ e(
        b,
        {
          disableRipple: !0,
          disableFocusRipple: !0,
          disableTouchRipple: !0,
          color: o ? "error" : "info",
          $hasError: o,
          ...r
        }
      ),
      i === "switch" && /* @__PURE__ */ e(
        m,
        {
          disableRipple: !0,
          disableFocusRipple: !0,
          disableTouchRipple: !0,
          color: o ? "error" : "info",
          ...r
        }
      )
    ]
  }
);
export {
  T as ChoiceBox
};
//# sourceMappingURL=index91.mjs.map
